import { Component, Input, OnChanges, SimpleChanges } from "@angular/core";

@Component({
  selector: "app-validation-message",
  templateUrl: "./validation-message.component.html",
  styleUrls: ["./validation-message.component.scss"],
})
export class ValidationMessageComponent implements OnChanges {
  @Input() validation: any;
  public requiredLength: number;
  public validationType: string;

  ngOnChanges(changes: SimpleChanges): void {
    const { validation } = changes;
    if (validation && validation.currentValue) {
      const requiredLength =
        validation?.currentValue?.minlength?.requiredLength;
      this.requiredLength = requiredLength;
      const validationType =
        Object.keys(this.validation).length > 0
          ? Object.keys(this.validation)[0]
          : null;
      if (validationType) {
        this.validationType = validationType;
      }
    }
  }
}
